import React from 'react'
function AboutFour() {
    return (
        <div>
            {/* rts about area start */}
            <div className="rts-about-area rts-section-gap about-home-seven">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="thumbnail">
                                <img src="assets/images/about/main/06.jpg" alt="about_image" />
                                <img
                                    src="assets/images/about/main/about-02-sm.jpg"
                                    alt="small"
                                    className="small"
                                />
                                <div className="experience-area six">
                                    <h2 className="title">100%</h2>
                                    <span>Client Satisfaction</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="text-start home-seven-about">
                                <p className="pre-title">More About Aviteus</p>
                                <h3 className="title">
                                    Focused on Clarity. Driven by Trust. Built for Growth.
                                </h3>
                            </div>
                            <div className="inner-about-home-7">
                                <p className="disc">
                                    We started Aviteus to make accounting simple and useful for everyday decisions. Our roots in healthcare taught us the value of accuracy and care. Today, we serve SMEs and startups across the UK with the same standard. You get a steady team, clear timelines and reports you can act on.
                                </p>
                                {/* ingle about start */}
                                <div className="about-single-home-7">
                                    <div className="icon">
                                        <img src="assets/images/about/main/icon/01.svg" alt="" />
                                    </div>
                                    <div className="discription">
                                        <h6 className="title">Qualified Team</h6>
                                        <p className="disc">
                                            Our accountants hold ICAEW, ACCA and CIMA qualifications. We work across Xero, Sage and QuickBooks, and we support migrations and training.
                                        </p>
                                    </div>
                                </div>
                                {/* ingle about end */}
                                {/* ingle about start */}
                                <div className="about-single-home-7">
                                    <div className="icon">
                                        <img src="assets/images/about/main/icon/02.svg" alt="" />
                                    </div>
                                    <div className="discription">
                                        <h6 className="title">Secure Cloud Tools</h6>
                                        <p className="disc">
                                            We use secure cloud tools with real-time access. Simple dashboards, monthly insights and proactive notes on risks and opportunities.
                                        </p>
                                    </div>
                                </div>
                                {/* ingle about end */}
                                {/* ingle about start */}
                                <div className="about-single-home-7">
                                    <div className="icon">
                                        <img src="assets/images/about/main/icon/03.svg" alt="" />
                                    </div>
                                    <div className="discription">
                                        <h6 className="title">Fixed Pricing</h6>
                                        <p className="disc">
                                            You get fixed pricing, plain language and a dedicated manager who understands your goals. No hidden fees or surprise bills.
                                        </p>
                                    </div>
                                </div>
                                {/* ingle about end */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts about area end */}
        </div>
    )
}

export default AboutFour